export const TermsOfUsePage = () => {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100">
        <div className="max-w-3xl mx-auto px-6 h-16 flex items-center">
          <a href="/" className="flex items-center">
            <img src="/horizontal-1.png" alt="Vkonekte" className="h-32 w-auto" />
          </a>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-16">
        {/* English */}
        <section className="mb-16">
          <h1 className="text-4xl font-extrabold text-gray-900 mb-2">Terms of Use</h1>
          <p className="text-sm text-gray-400 mb-10">Last updated: April 9, 2026</p>

          <div className="prose prose-gray max-w-none space-y-8 text-gray-700 leading-relaxed">
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">1. Acceptance of Terms</h2>
              <p>
                By accessing or using the Vkonekte platform, you agree to be bound by these Terms of
                Use. If you do not agree to these terms, please do not use our services.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">2. Use of the Platform</h2>
              <p>You agree to use the platform only for lawful purposes and in a manner that does not:</p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Infringe the rights of others</li>
                <li>Violate any applicable laws or regulations</li>
                <li>Distribute spam or unsolicited messages</li>
                <li>Attempt to gain unauthorized access to any part of the platform</li>
                <li>Upload malicious code or harmful content</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">3. Account Responsibilities</h2>
              <p>
                You are responsible for maintaining the confidentiality of your account credentials
                and for all activities that occur under your account. Notify us immediately of any
                unauthorized use of your account.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">4. Intellectual Property</h2>
              <p>
                All content on the Vkonekte platform, including courses, materials, logos, and
                software, is owned by Vkonekte or its licensors. You may not reproduce, distribute,
                or create derivative works without explicit written permission.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">5. Payments and Refunds</h2>
              <p>
                All purchases are final unless otherwise specified. Refund requests may be considered
                within 7 days of purchase if the course content has not been accessed. Contact our
                support team for assistance.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">6. Termination</h2>
              <p>
                We reserve the right to suspend or terminate your account at our sole discretion if
                you violate these Terms of Use. You may also terminate your account at any time by
                contacting our support team.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">7. Disclaimer of Warranties</h2>
              <p>
                The platform is provided "as is" without warranties of any kind. We do not guarantee
                that the service will be uninterrupted, error-free, or meet your specific requirements.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">8. Limitation of Liability</h2>
              <p>
                To the maximum extent permitted by law, Vkonekte shall not be liable for any indirect,
                incidental, special, or consequential damages arising out of your use of the platform.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">9. Changes to Terms</h2>
              <p>
                We may update these Terms of Use from time to time. Continued use of the platform
                after changes constitutes acceptance of the new terms.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">10. Contact</h2>
              <p>
                Questions about these Terms? Contact us at{" "}
                <a href="mailto:vkonekte.official@gmail.com" className="text-blue-600 hover:underline">
                  vkonekte.official@gmail.com
                </a>
              </p>
            </div>
          </div>
        </section>

        <hr className="border-gray-200 mb-16" />

        {/* Russian */}
        <section>
          <h1 className="text-4xl font-extrabold text-gray-900 mb-2">Условия использования</h1>
          <p className="text-sm text-gray-400 mb-10">Последнее обновление: 9 апреля 2026 г.</p>

          <div className="prose prose-gray max-w-none space-y-8 text-gray-700 leading-relaxed">
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">1. Принятие условий</h2>
              <p>
                Используя платформу Vkonekte, вы соглашаетесь соблюдать настоящие Условия
                использования. Если вы не согласны с этими условиями, пожалуйста, не используйте
                наши сервисы.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">2. Использование платформы</h2>
              <p>Вы обязуетесь использовать платформу только в законных целях и способами, которые не:</p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Нарушают права других лиц</li>
                <li>Противоречат применимым законам и нормативным актам</li>
                <li>Распространяют спам или нежелательные сообщения</li>
                <li>Направлены на несанкционированный доступ к платформе</li>
                <li>Загружают вредоносный код или вредный контент</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">3. Ответственность за аккаунт</h2>
              <p>
                Вы несёте ответственность за сохранность учётных данных вашего аккаунта и за все
                действия, совершённые под вашим аккаунтом. Немедленно уведомите нас о любом
                несанкционированном использовании вашего аккаунта.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">4. Интеллектуальная собственность</h2>
              <p>
                Весь контент на платформе Vkonekte, включая курсы, материалы, логотипы и программное
                обеспечение, принадлежит Vkonekte или его лицензиарам. Воспроизведение, распространение
                или создание производных работ без письменного разрешения запрещено.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">5. Оплата и возврат средств</h2>
              <p>
                Все покупки являются окончательными, если не указано иное. Запросы на возврат
                рассматриваются в течение 7 дней с момента покупки при условии, что контент курса
                не был просмотрен. Обратитесь в нашу службу поддержки.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">6. Прекращение доступа</h2>
              <p>
                Мы оставляем за собой право приостановить или удалить ваш аккаунт по нашему
                усмотрению в случае нарушения настоящих Условий. Вы также можете удалить аккаунт
                в любое время, обратившись в поддержку.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">7. Отказ от гарантий</h2>
              <p>
                Платформа предоставляется «как есть» без каких-либо гарантий. Мы не гарантируем
                бесперебойную и безошибочную работу сервиса.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">8. Ограничение ответственности</h2>
              <p>
                В максимальной степени, допустимой законом, Vkonekte не несёт ответственности за
                косвенные, случайные, специальные или последующие убытки, возникшие в результате
                использования платформы.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">9. Изменения условий</h2>
              <p>
                Мы можем периодически обновлять настоящие Условия. Продолжение использования
                платформы после изменений означает согласие с новыми условиями.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">10. Контакты</h2>
              <p>
                По вопросам об Условиях использования обращайтесь:{" "}
                <a href="mailto:vkonekte.official@gmail.com" className="text-blue-600 hover:underline">
                  vkonekte.official@gmail.com
                </a>
              </p>
            </div>
          </div>
        </section>
      </main>

      <footer className="border-t border-gray-100 mt-16 py-8 text-center text-sm text-gray-400">
        © {new Date().getFullYear()} Vkonekte. All rights reserved.
      </footer>
    </div>
  )
}
